// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UPwQ","content":"styles_content__nPSXK"};